<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead03">
                <div class="inner4">
                    <h1><img class="smaller" src="/img_report_biei/title.png" srcset="/img_report_biei/title@2x.png 2x" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会）「カメラと旅する北海道・美瑛町」" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2021年11月3日（水・祝）〜12月11日（土）にオンライン開催された東京カメラ部2021写真展 Online Exhibition「だから、世界は美しい。」。<br><br>
                            写真展に連動し、協賛団体様のご提供イベント、東京カメラ部の主催者自主企画など数々のオンライントークショーが開催されました。2021年11月22日（月）には、声優の石川由依さん、美瑛町長 角和浩幸さん、東京カメラ部10選の谷田洋史さんにご出演いただき、「カメラと旅する北海道・美瑛町」と題し、四季折々の写真を見ながら美瑛町の魅力を語っていただきました。また、美瑛町と東京カメラ部による、スマホアプリを活用した、写真のチカラを活かした新しい観光PR施策についての発表も行いました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「みなさんこんばんは。東京カメラ部の塚崎です。東京カメラ部2021写真展 Online Exhibitionカメラと旅する北海道美瑛町へようこそ。美瑛町長 角和浩幸さんと、東京カメラ部10選の谷田洋史さんをお迎えしまして、みなさんと共に美瑛町を旅することができればと思っております。まずは町長お願いいたします」<br>
                            <br>
                            角和「みなさんこんばんは。美瑛町長の角和です。本日はどうぞよろしくお願いいたします」<br>
                            <br>
                            谷田「写真家の谷田と申します。本日はよろしくお願いいたします」<br>
                            <br>
                            塚崎「スペシャルゲストが僕の隣にいらっしゃいます。名作中の名作『ヴァイオレット・エヴァーガーデン』でヴァイオレット・エヴァーガーデン役を演じ、名誉ある第15回声優アワード主演女優賞を受賞された石川由依さんです」<br>
                            <br>
                            石川「みなさんこんばんは、石川由依です、よろしくお願いします」<br>
                            <br>
                            塚崎「東京カメラ部にも『ヴァイオレット・エヴァーガーデン』ファンは多く、石川さんがいらっしゃるということでみんな大興奮しております」<br>
                            <br>
                            石川「ありがとうございます。わたしのソロCDも飾っていただいてありがとうございます」<br>
                            <br>
                            塚崎「それでは石川さんとともに、谷田さんが撮影した美瑛町の写真を見ていきましょう」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/01.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            谷田「美瑛町で撮影をした桜の写真です。公園の整備された桜も美しいですが、このように野生でしっとりと咲く桜も趣があって美しいなと思い撮影した1枚です」<br>
                            <br>
                            角和「美瑛町は蝦夷山桜が多いのだろうと思いますが、本当に山の中にぽつんぽつんと自生しているところが美しいです。北海道ですので、新緑と桜、梅の花、こぶしの花、さまざまな花がいっぺんに咲き、色とりどりになるところが美しいと思い、わたしも見ています」<br>
                            <br>
                            塚崎「本州ではソメイヨシノが多いですが、北海道ではそうではない桜もあるんですね」<br>
                            <br>
                            角和「蝦夷山桜はソメイヨシノよりも濃い赤が出るのが特徴だと思います」<br>
                            <br>
                            石川「影と光のコントラストがとても美しく表現されていて、緑の中にぽつんとあるピンクが美しいと感じました。おそらく朝なんでしょうか。それがよく伝わってきて、深呼吸がしたくなるような写真ですね」<br>
                            <br>
                            谷田「まさに朝の写真です」<br>
                            <br>
                            塚崎「石川さんのコメントは的確ですね。石川さんは写真も撮られるんですよね。一度だけ石川さんが撮られているドイツの写真を見せていただきました」<br>
                            <br>
                            石川「ドイツも美しい場所だったので撮りがいがありました」<br>
                            <br>
                            塚崎「構図がどれも素晴らしくて、センスがある方は何をやってもセンスがあるのだなと思いました。次の作品です。就実の丘の写真ですね」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/02.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>谷田「就実の丘から西の方を向いて撮影しています。日没が近い、日が傾いた時間帯に、北瑛に向いて撮影しています。暗いところと明るいところがしっかり出ているところ、トラクターが小さく写っているところに、ストーリーがあるなと思い撮影した1枚になります」<br>
                            <br>
                            角和「就実の丘そのものは旭川市なのですが、そこから隣接した美瑛町へ連なる丘があり、とても美しい地域です。わたしも農業を営んでおりますが、今日も充実した仕事ができたな、というような、生産者の方の思いも伝わってくる素晴らしい写真だと思います」<br>
                            <br>
                            塚崎「畑をやっていらっしゃるので、実感がこもっていらっしゃいますね。石川さんはいかがですか」<br>
                            <br>
                            石川「東京に住んでいるとこんな景色を日本で見られるのかというくらいに雄大で、物語も感じることができるなと思います。折り重なった線が美しいですし、緑にもいろんな緑が存在するんだなと感じました」<br>
                            <br>
                            谷田「まさにその通りで、それをいかに写真で表現するかという点が難しくも楽しいところです」<br>
                            <br>
                            塚崎「YouTubeではコメントも大募集中ですので、よろしくお願いします。絵画のように鮮やかで奥深い緑ですね。こんなコメントいただいています。続いての写真です。ジャガイモ畑でしょうか」
                            </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/03.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「そうです。白い花が咲いています。夏場に撮影しており、夏の雲、ジャガイモ畑、青い空。久石譲さんの『Summer』という曲が聞こえてきそうだなと」<br>
                            <br>
                            角和「わたしにとっての美瑛町は、この1枚かもしれません。農業に憧れて美瑛町に移住しましたが、農業といえばジャガイモで、ジャガイモ畑で働きたいという気持ちがあっての移住でした。ジャガイモの花も白だけでなく、ピンクがかったもの、紫がかったものなどさまざまな種類があり、そのときどきによって我々の目を楽しませてくれる作物だと思っています」<br>
                            <br>
                            石川「さわやかですね。これだけで夏だ！と言われているような写真ですね。わたしは雲の影の部分が好きですね。なぜかわからないのですが、夏の写真を見ると、雲の影の部分に惹かれるので、この写真もとてもカッコイイと思います！」<br>
                            <br>
                            塚崎「作物がここまで画になるのも珍しいですよね。美瑛町では、ジャガイモがたくさん栽培されていて、種芋も作られているんですよね」<br>
                            <br>
                            石川「あまりジャガイモのことを知らないと、この美しい風景がジャガイモだとわからないくらい美しい緑ですよね」<br>
                            <br>
                            塚崎「ジャガイモは食べておいしい、見て美しいということですね。美瑛町のジャガイモを使った商品もここに並んでいます。これは有楽町にあるアンテナショップ『丘のまち美瑛』で購入することができますし、オンライン販売もされています。「美瑛町」「オンラインショップ」で検索してみてください。コメントもいただいています。『雲が近い』。たしかにそうですね。『群青世界ですね！』『雲の影めちゃわかります』など、たくさんきています。『石川由依さんのコメントも踏まえて見ると、自分とはまた少し違った視点で写真を楽しめて面白いです。すでに撮り終えられているものなのに、見る人の数だけ写真の魅力が新たに引き出されているのがうれしい驚きです』。こんなコメントもきています」<br>
                            <br>
                            石川「専門的なことはいえませんから思ったことを話しています。写真を見て感じることはみなさん違うでしょうし、それを共有できるのは楽しいですね」<br>
                            <br>
                            塚崎「五稜の丘の写真に移ります」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/04.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「麦畑です。山の稜線の向こう側に太陽があり、その光芒がキレイに伸びているという点、手前にある麦が太陽の光を受け、いまにも動き出しそうな点を意識しながら撮りました」<br>
                            <br>
                            角和「『麦秋』という言葉があります。7月半ば、麦が熟して黄金色に輝く時期があるのですが、美瑛町が光り輝く季節はその頃かなと思います。美瑛町では小麦の作付面積が最も広く、町を代表する作物です」<br>
                            <br>
                            石川「わたしのイメージですが、風の谷のナウシカの金色の草原を想像しました。おっしゃっていたように、動きを感じるというか、止まっているはずの写真なのに風を感じますね」<br>
                            <br>
                            谷田「思ったことが伝わっていて、とてもありがたいです」<br>
                            <br>
                            塚崎「美瑛町の小麦はパンにもよく使われていますね」<br>
                            <br>
                            角和「いま最もブランド化しようと力を入れているのが小麦です。実際に美瑛町の小麦はおいしくてパンやうどんなど、いろいろな商品になっております」<br>
                            <br>
                            石川「パンはよく作ります。美瑛町の小麦も使ってみたいですね」<br>
                            <br>
                            角和「パンに向くのは『ゆめちから』という超強力粉です。モチモチのパンが作れます。もっともっと多くの人に味わっていただきたいと思います」<br>
                            <br>
                            塚崎「コメントきております。『年間300日ほど美瑛町に行っていますが、日々違った風景で魅了されます』」<br>
                            <br>
                            石川「365日のうちの一瞬がこの写真ということですよね」<br>
                            <br>
                            塚崎「美瑛町は風景写真の聖地といわれていて、少し悪い言い方ですが、『美瑛マジック』というのがあり、いつもよりも2段は腕前が良くなると言われています」<br>
                            <br>
                            谷田「風景に撮らされちゃうといいますか」<br>
                            <br>
                            石川「初心者だったら、美瑛町でうまい写真が撮れればテンションあがりますよね。わたしも初心者なのでぜひ訪れてみたいです」<br>
                            <br>
                            塚崎「『美瑛小麦のスタンプラリーをしていますよね』というコメントもきています」<br>
                            <br>
                            角和「今年はじめて取り組んだ、美瑛小麦を使ったお店を巡るスタンプラリーです。ご協力ありがとうございます」<br>
                            <br>
                            塚崎「山から見える太陽の光の線がヤバイ、というコメントです」<br>
                            <br>
                            石川「子どもの頃に書いた太陽の絵のようになるんだなって驚きました」<br>
                            <br>
                            谷田「絞り込んで撮影しています。少しだけコツが必要です」<br>
                            <br>
                            塚崎「『逆光を上手く利用していて、黄金色に輝いているのがいい！！』というコメントです。この方、とてもわかってくださっていますね。順光だとこうは撮れないですよね」<br>
                            <br>
                            谷田「とてもうれしいコメントです」<br>
                            <br>
                            塚崎「次の写真。すごい1枚ですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/05.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「秋に撮影しています。寒暖差が大きくなると霧が頻繁に発生するようになり、霧がベールのようになって丘の上にかぶさるのが美しいです。また太陽の光を受けた木の陰が美しいと思います」<br>
                            <br>
                            角和「地形のせいでしょうか、よく霧は出ます。真っ白になるようなこともありますが、とても素晴らしい瞬間を切り取ってくださったと感じます。夏の朝に霧が出ると、その日はものすごく暑くなります。霧が出てさわやかだな、高原みたいだな、と思うと日中暑くて農作業をすると大変だなというのが体に染みついています」<br>
                            <br>
                            塚崎「美瑛町は寒暖差が激しいために農作物がおいしくなるんです。トウモロコシはメロンのように甘いので収穫してその場で食べられます」<br>
                            <br>
                            角和「うちでも白いトウモロコシを作っていますが、もぎたてを食べるのがいちばんおいしいと思います」<br>
                            <br>
                            石川「行かないと食べられない、ということですね」<br>
                            <br>
                            塚崎「フリーズドライの商品が出ているので、ぜひそちらをお試しいただきたいです。トウモロコシだけでなく、乳製品のものもあります。コメントもきています。『何回も行っていますが、移住したいです』。町長、きました！」<br>
                            <br>
                            角和「待ってました！移住のためのお試しもありますし、テレワークのための住居も整備しておりますので、さまざまな形で美瑛町にお越しいただければうれしいです」<br>
                            <br>
                            塚崎「次の作品です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/06.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「晩秋、まだカラマツの紅葉が落葉する前に初雪の日を迎えました。山々が折り重なり、カラマツが織りなすデザインがとても見事だなと思い撮影しました」<br>
                            <br>
                            角和「カラマツの紅葉は本当に美しいです。もっと認知していただきたいと思っているのが秋の紅葉です。夏の緑の丘、冬の白銀の世界もキレイですが、秋はまだ注目度が低いですね。秋の風景にも宝箱はあるのではないかと思っています」<br>
                            <br>
                            石川「茶と白が折り重なった姿が美しいと思いますし、きっと遠くから見ると雄大な景色だと思うのですが、ここだけを切り取るというのがすごいなって思いました」<br>
                            <br>
                            塚崎「食べ物がおいしいのも秋ですよね」<br>
                            <br>
                            角和「そうですね。美瑛町、北海道の農業の収穫は秋に一気にきますから、さまざまなおいしいものが揃う季節です」<br>
                            <br>
                            塚崎「観光のピークは5〜7月くらいで秋になると徐々に減ってくるようですが、食べ物ならば秋。だからわたしは必ず秋に行くんですよ」<br>
                            <br>
                            角和「10月になると、いつ雪が降ってもおかしくないという感じで、残念ながらピークは夏という傾向は続いています」<br>
                            <br>
                            塚崎「コメントにいきます。『自分は美瑛生まれの美瑛育ちです。麦の花、ジャガイモの花もよいですよ。霧から見える美馬牛小学校の屋根が綺麗です』ということですが、美馬牛小学校は確かに美しいですよね」<br>
                            <br>
                            角和「小学校に塔がありまして、霧の中や雪の中から、さまざまな表情で塔が見えます。美馬牛にしかない風景だと思います」<br>
                            <br>
                            塚崎「次の作品です。マイルドセブンの丘の1枚ですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/07.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「太陽の周りに輪が見えています。『ハロ』や『傘』と呼ぶのですが、それと筋状の雲の組み合わせによって、カラマツ林がオーラをまとっている感じだなと思い撮りました。なかなか見られない風景だと思います」<br>
                            <br>
                            角和「わたしはこのすぐそばに住んでいますが、これだけの美しさを醸し出している風景を見ることは稀ですね」<br>
                            <br>
                            石川「こんな景色が見られるところに町長が住んでいる、というのがまず驚きですね。この写真は後光が差しているかのような神々しさで、拝みたくなるような写真ですよね」<br>
                            <br>
                            谷田「何度か通って撮っていますが、このような条件が重なったのは、これを撮影したときだけですね。虹よりも珍しい気象現象かもしれません」<br>
                            <br>
                            塚崎「おそらく、視聴者のみなさまは美瑛町に撮影に行きたい、と思っていらっしゃることでしょう。じゃあ、撮りにいくときにどこにいけばいいだろうという情報が必要だと思います。撮影スポットへ案内してくれて、その場所に着くと解説をしてくれるという無料のスマホアプリがあるんです。それが、ソニーが開発した Sound AR&trade; を楽しむためのエンタテインメントアプリ『Locatone&trade;（ロケトーン）』というアプリです。このたび、その『Locatone&trade;』内に東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』を開設しました。そして、そのナレーションを石川由依さんにご担当いただきました。石川さん、収録されてみていかがでしたか？」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/08.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            石川「美瑛町のさまざまな素敵な風景についてナレーションさせていただいて、ナレーションをするたびに風景が広がってくるような感覚で楽しませていただきました。豆知識みたいなものも内容に含まれていて、わたし自身が驚きや発見がたくさんあったので、聴いてくださる方も美瑛町のことを知っていきながら撮影していただけるのではないかなと思います」<br>
                            <br>
                            塚崎「ありがとうございます！それでは、美瑛町を写した次の作品を見ていきましょう。新栄の丘展望公園からの1枚です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/09.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「春に撮影しています。残雪の十勝岳連峰、パッチワークの丘といわれるいろいろな色が組み合わさっている丘です。ここにはフォトスポットがありそこから撮影しました。まさに『THE美瑛町』を凝縮した1枚ですね」<br>
                            <br>
                            角和「美瑛町を代表する観光スポットが新栄の丘展望公園です。最近になって近隣の林を伐採したため少しずつ景色が変わっているかもしれませんが、それでも美瑛町の美しさは保たれていると思いますし、守っていかないといけないと考えています」<br>
                            <br>
                            石川「写真なので平面のはずなのに、すごく立体感を感じます。特に山が立体的で奥行きを感じますね」<br>
                            <br>
                            塚崎「真ん中に写っている赤い屋根の家は、実はどなたも住んでいません。観光のために残しているんですよね」<br>
                            <br>
                            角和「町でメンテナンスしています。元々は住んでいる方がいらっしゃいましたが、観光スポットとして有名になったので、これを守るために、役場の職員たちの手で屋根にペンキを塗っています」<br>
                            <br>
                            塚崎「偶然ある景色ではなく、みなさんにどうやったらキレイに見えるかという努力もされているわけです。コメントきています。先ほどの東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』について、新時代のスタンプラリーですね、ときています。ご褒美は石川さんの声、ということですね。では実際に、一部聴いていただきたいと思います。新栄の丘展望公園で流れるナレーションの一部です」<br>
                            <br>
                            ナレーション（石川）「思わず深呼吸したくなりませんか？ここは新栄の丘展望公園。美瑛らしい丘の風景が一望できる、人気の展望スポットです。東側にはパッチワークの丘の真ん中に赤い屋根の家がぽつんと佇んでいて、遠方には十勝岳連峰の山並みを一望することができます」<br>
                            <br>
                            塚崎「どうですか、谷田さん。ご自身の写真とナレーションが合わさってくると」<br>
                            <br>
                            谷田「わたしの写真を解説していただいているようでとてもうれしいです。写真を撮っていてよかったです」<br>
                            <br>
                            角和「声に聞き惚れてしまいました」<br>
                            <br>
                            塚崎「美瑛町と石川由依さんの語りがどんな化学反応を起こしてくれるのかとてもわくわくします。きっと素敵なはず。というコメントきています。それはもう素晴らしいものだと確信しています。いまはYouTubeで聴いていただきましたが、東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』ではバイノーラル録音という特殊な方法で収録しているため、もっと立体感があります。ぜひイヤホンで聴いていただきたいです。次の作品です。白金青い池です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/10.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「とても気に入っている作品です。白金青い池のライトアップです。冬期間ライトアップされているのですが、池が凍る前のわずかな期間はこの写真のような光景が楽しめます」<br>
                            <br>
                            角和「美しいですね。ライトアップは11月1日から4月30日まで毎晩おこなっています」<br>
                            <br>
                            石川「声を出すのもためらわれるくらいの静けさと神秘的な空気がある美しい写真だと思います」<br>
                            <br>
                            塚崎「青い池で聴くことができる東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』のナレーションの一部を公開します」<br>
                            <br>
                            ナレーション（石川）「そろそろ白金青い池が見えてきましたか？見てください、この幻想的な青色。まるで絵の具を溶かしたような青い水面に、立ち枯れた白い木々が神秘的な雰囲気を醸し出します。写真を撮る際には、池の前にある柵の柱の上にカメラを置くと、安定して撮りやすいのでおすすめです。その際、池の中にカメラを落とさないように注意してください」<br>
                            <br>
                            石川「ナレーションでは撮り方も説明してくれるので、きっとその通りに撮ったら、こんな素敵な作品も撮れるということですよね」<br>
                            <br>
                            塚崎「東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』の中にはアドバイスが入っているので、ぜひ参考にしていただきたいです。続いて、クリスマスツリーの木です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_biei/11.jpg" alt="カメラと旅する北海道・美瑛町" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            谷田「有名な撮影スポットです。日没、西側を向くことになるので、夕陽と絡めて撮影することが多いのですが、この日は空がキレイな色だったので、その雰囲気を出すように撮りました」<br>
                            <br>
                            角和「実はこの景色の手前に電線が張ってあり、少し前までは写真に電線が写り込むような状態でした。そのため、電線を写さないようにするために撮影者が畑に侵入することもあったのですが、この電線を後ろの方に移動させまして、写真を撮る方のためにも、農家の方のためにもなるように配慮しました」<br>
                            <br>
                            塚崎「この画角で撮ろうとすると電線が入ってしまっていたんです。そうならないように一区画だけ電線を後ろに移動していただいたんです。これは写真家の皆さんと一緒に美瑛町さんへ提案したところ実現してくださいました。写真を撮る人に寄り添う美瑛町という代表する出来事じゃないでしょうか。補足しますと、農地に入ってしまうというのは、私有地への不法侵入という問題だけではなく、靴の裏の細菌や害虫が畑を汚染してしまうかもしれないという深刻な問題なんです。」<br>
                            <br>
                            角和「美瑛町では見つかっていませんが、ジャガイモのシストセンチュウという害虫が畑に入ると、もうそこではジャガイモが作れなくなってしまいます。本当に危険な害虫で、そういうことを避けるためにも、無断での立ち入りは控えていただきたいです」<br>
                            <br>塚崎「美瑛町でこれが起きると、日本からフライドポテトがなくなってしまうかもくらい深刻なことなんです。さて、ここのナレーションを聴いてみましょう」<br>
                            <br>
                            ナレーション（石川）「その名の通り、クリスマスツリーのような美しい円錐形をした一本の木。一年中、美しい写真が撮れるスポットとして人気です」<br>
                            <br>
                            塚崎「コメントいただいています。『これはぜひ現地で聴いてみたいですね。バイノーラル録音!?雄大な自然と最先端の技術がコラボレーションしているって面白い企画ですね。期待がどんどん膨らみます』ということです。ありがとうございます。先ほども畑の話をしましたが、撮影者のマナー問題のバランスもうまく撮ろうと美瑛町では考えてくださっています」<br>
                            <br>
                            角和「美瑛町の人口は1万人を切っています。コロナ前の観光客は年間240万人、人口の240倍の方々が美瑛町を楽しんでくださっていたのですが、やはりそれだけの人数差があると観光客の方のマナーの問題が目立ってきてしまいます。畑の中に侵入するということもそうですし、トラクターの出入り口に車を停めるなど、さまざまなマナーの問題があります。いまコロナ禍で問題は収まっていますが、また旅行が活発になったときに同じような問題に直面しないように、いまのうちからマナーに関してお話させていただき、地元の方も観光の方も楽しめる美瑛町でありたい、と考えております」<br>
                            <br>
                            塚崎「この問題に関しても東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』の中で石川さんが解説してくださっています。『Locatone&trade;』をスマホにダウンロードして、東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』ツアーを開始すると、各スポットを訪れるたびにナレーションが流れるほか、合間に石川さんのエクストラ音声や、全てのスポットを訪れると特別なエンディングナレーションもありますので、ぜひ制覇していただきたいです。また、『カメラと旅する北海道・美瑛町』以外でも、美瑛町の公式Facebookアカウント「写真で旅する～北海道美瑛」では美瑛町を被写体として撮影された写真を紹介しております。観光の最新情報は、美瑛町観光協会のホームページをご確認ください。本日の動画は、東京カメラ部YouTubeチャンネルや東京カメラ部Instagramアカウント「Instagram Video」にもアーカイブ掲載しますのでぜひご覧ください。本日はどうもありがとうございました」<br>
                            <br>
                            角和「本日はどうもありがとうございました。ぜひ美瑛町にお越しください」<br>
                            <br>
                            谷田「ありがとうございました。早速、美瑛町にいって東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』試してみたいと思います」<br>
                            <br>
                            石川「今日は谷田さんの写真を見て、町長のお話も聞いて、わたしも一度美瑛町に行きたいと思いました。ぜひみなさんも東京カメラ部チャンネル『カメラと旅する北海道・美瑛町』を楽しんでみてください」<br>
                            <br><br>
                            ※Sound ARとは、現実世界に仮想世界の音が混ざり合うソニーによる新感覚の音響体験です。<br>
                            ※Sound AR&trade;およびLocatone&trade;はソニーグループ株式会社またはその関連会社の商標です。
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
				
                <section class="movBlock">
                    <div class="inner4">
                        <h2>このレポートのアーカイブ動画</h2>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/iiWcWYlD27E" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div><!-- /inner4-->
                </section><!-- /movBlock-->

                <section class="btnBlock">
                    <div class="inner4">
                      <router-link to="/events/archives" class="StandardBtn">主催者公式イベントアーカイブ</router-link>
                    </div><!-- /inner4-->
                </section><!-- /btnBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <UpButton />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}

</style>
